var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.02,.02V20.02H20.02V.02H.02ZM19.02,19.02H1.02V1.02H19.02V19.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.03,6.22c1.07,0,2.05,.67,2.45,1.67l.93-.37c-.34-.87-1.01-1.55-1.82-1.94,.4-.4,.65-.95,.65-1.56,0-1.21-.99-2.2-2.2-2.2s-2.2,.99-2.2,2.2c0,.61,.25,1.16,.65,1.56-.82,.39-1.48,1.08-1.82,1.94l.93,.37c.39-1,1.38-1.67,2.45-1.67Zm-1.2-2.2c0-.66,.54-1.2,1.2-1.2s1.2,.54,1.2,1.2-.54,1.2-1.2,1.2-1.2-.54-1.2-1.2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.14,
    y: 3.73,
    width: 7.26,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.14,
    y: 6.21,
    width: 7.26,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.02,
    y: 8.7,
    width: 7.38,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.24,
    y: 11.61,
    width: 7.26,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.24,
    y: 14.09,
    width: 7.26,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.12,
    y: 16.58,
    width: 7.38,
    height: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.49,18h7.41v-6.82h-7.41v6.82Zm1-5.82h5.41v4.82h-5.41v-4.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent1);
export default __webpack_public_path__ + "static/media/Agent-1.1069136ac8c80c7f45b872a542e29fe9.svg";
export { ForwardRef as ReactComponent };